import { useEffect, useState, useRef } from "react";
import { breadcrumb } from "../utils/sentry";
import { showMessage } from "../utils/snackbar";

const TIMEOUT_MS = 5000;

export const useOnlineStatusWithTimeout = () => {
    const [offlineTimeoutExceeded, setOfflineTimeoutExceeded] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    useEffect(() => {
        const handleOnline = (e: any) => {
            console.info('[useOnlineStatus] Online', e);
            breadcrumb('useOnlineStatus', 'Online', { event: e });
            showMessage("Verbinding met internet hersteld", "info", 5000);

            clearTimeout(timeoutRef?.current);
            timeoutRef.current = undefined;

            setOfflineTimeoutExceeded(false);
        };

        const handleOffline = (e: any) => {
            console.info('[useOnlineStatus] Offline', e);
            breadcrumb('useOnlineStatus', 'Offline', { event: e });
            showMessage("Verbinding met internet verbroken", "warning");

            clearTimeout(timeoutRef?.current);
            timeoutRef.current = undefined;

            timeoutRef.current = setTimeout(() => {
                setOfflineTimeoutExceeded(true);
                timeoutRef.current = undefined;
            }, TIMEOUT_MS);
        };

        window.addEventListener("online", handleOnline, true);
        window.addEventListener("offline", handleOffline, true);

        return () => {
            window.removeEventListener("online", handleOnline, true);
            window.removeEventListener("offline", handleOffline, true);
            clearTimeout(timeoutRef?.current);
        };
    }, []);

    return offlineTimeoutExceeded;
};
